import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

export default function Modal({ setShowModal, showModal, modalContent }) {
  const { t } = useTranslation();
  const modalRef = useRef(null);
  const closeButtonRef = useRef(null);

  useEffect(() => {
    if (!showModal) {
      return undefined;
    }

    const previouslyFocusedElement = document.activeElement;
    const previousBodyOverflow = document.body.style.overflow;
    const pageWrapper = modalRef.current?.closest(".maderas-elegant.home-3");
    const previousPageOverflow = pageWrapper?.style.overflowY;

    document.body.style.overflow = "hidden";
    if (pageWrapper) {
      pageWrapper.style.overflowY = "hidden";
    }
    closeButtonRef.current?.focus();

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setShowModal(false);
        return;
      }

      if (event.key === "Tab") {
        const focusableElements = Array.from(
          modalRef.current?.querySelectorAll("button, a[href]") || []
        );
        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        if (event.shiftKey && document.activeElement === firstElement) {
          event.preventDefault();
          lastElement?.focus();
        } else if (!event.shiftKey && document.activeElement === lastElement) {
          event.preventDefault();
          firstElement?.focus();
        }
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = previousBodyOverflow;
      if (pageWrapper) {
        pageWrapper.style.overflowY = previousPageOverflow || "";
      }
      previouslyFocusedElement?.focus?.();
    };
  }, [setShowModal, showModal]);

  if (!showModal) {
    return null;
  }

  const closeOnBackdrop = (event) => {
    if (event.target === modalRef.current) {
      setShowModal(false);
    }
  };

  return (
    <div
      ref={modalRef}
      className="modal development-modal show"
      role="dialog"
      aria-modal="true"
      aria-labelledby="development-modal-title"
      onMouseDown={closeOnBackdrop}
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <button
            ref={closeButtonRef}
            type="button"
            className="development-modal__close"
            aria-label={t("app.cerrarModal")}
            onClick={() => setShowModal(false)}
          >
            <i className="far fa-times" aria-hidden="true"></i>
          </button>

          <div className="modal-body">
            {modalContent?.banner && (
              <div className="development-modal__image">
                <img
                  width={800}
                  height={300}
                  src={modalContent.banner}
                  alt={modalContent?.nombre || modalContent?.ciudad || ""}
                />
              </div>
            )}

            <div className="development-modal__details">
              {(modalContent?.ciudad || modalContent?.nombre) && (
                <div className="development-modal__heading">
                  {modalContent?.ciudad && (
                    <span>{modalContent.ciudad}</span>
                  )}
                  <h2 id="development-modal-title">
                    {modalContent?.nombre}
                  </h2>
                </div>
              )}

              {modalContent?.descripcion && (
                <div
                  className="development-modal__description"
                  dangerouslySetInnerHTML={{
                    __html: modalContent.descripcion,
                  }}
                />
              )}

              <div className="development-modal__actions">
                {modalContent?.ubicacion && (
                  <a
                    href={modalContent.ubicacion}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fa-light fa-location-dot" aria-hidden="true"></i>
                    <span>{t("app.verUbicacion")}</span>
                  </a>
                )}
                {modalContent?.planoMaster && (
                  <a
                    href={modalContent.planoMaster}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fa-light fa-map" aria-hidden="true"></i>
                    <span>{t("app.verPlanoMaster")}</span>
                  </a>
                )}
                <button type="button">
                  <i className="fa-light fa-book-open" aria-hidden="true"></i>
                  <span>{t("app.verCatalogo")}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
